export default __webpack_public_path__ + "static/media/jackpot2.89a951b6.png";